import { BarChart, Bar, CartesianGrid, XAxis, YAxis } from 'recharts';

// Our Hooks
import useGetBurnDownChart from 'hooks/Burdown/queries/useGetBurnDownChart';

// Our Utils
import { dollarFormatter } from 'shared/utils';

function ExportableReportBurndownChart() {
	const { isSuccess, data } = useGetBurnDownChart();

	if (!isSuccess) return <div>Loading...</div>;

	if (isSuccess) {
		const { burnDownCalculation } = data;
		const dynamicCharts = burnDownCalculation.map((currentData, index) => ({
			calculation: currentData,
			name: `Year-${index + 1}`
		}));
		return (
			<BarChart width={300} height={260} data={dynamicCharts}>
				<defs>
					<linearGradient
						id="customGradient"
						x1="0"
						y1="0"
						x2="0"
						y2="1"
					>
						<stop offset="0%" stopColor="#206EA7" stopOpacity={1} />
						<stop
							offset="100%"
							stopColor="#CCE9FF"
							stopOpacity={1}
						/>
					</linearGradient>
				</defs>
				<CartesianGrid />
				<XAxis
					dataKey="name"
					tick={{ fill: 'black', fontSize: '0.75rem' }}
					interval={0}
				/>
				<YAxis
					tickFormatter={(value) => {
						const formattedY = dollarFormatter.format(value);
						return formattedY;
					}}
					tick={{ fill: 'black', fontSize: '0.75rem' }}
					width={85}
				/>
				<Bar dataKey="calculation" fill="url(#customGradient)" />
			</BarChart>
		);
	}
}

export default ExportableReportBurndownChart;
